export const isLoginError = (state) => state.entities.users.isLoginError;
